import React from 'react';
import EditIcon from '@material-ui/icons/CreateOutlined';
import { ICustomTheme } from 'interfaces';
import { useTheme } from '@material-ui/core';

export const CustomEditIcon = ({ color }: { color?: string }) => {
  const theme: ICustomTheme = useTheme();
  return (
    <EditIcon
      style={{
        color: color || theme.colors.paletteFromBO.main,
        fontSize: theme.typography.h3.fontSize,
      }}
    />
  );
};
